import { createEmptyContext } from '../../../../utils/create-empty-context';
export const TicketRedemptionCodeFormContextInstance = createEmptyContext();
